import { WbsItemStatus } from '../../../../../../../../../domain/entity/WbsItemEntity'
import { WbsItemTypeVO } from '../../../../../../../../../domain/value-object/WbsItemTypeVO'
import { CalendarDateVO } from '../../../../../../../../../domain/value-object/CalendarDateVO'
import { DatePosition } from './GanttBackground'
import { calcProgressPositionPercent } from './GanttSlider'

export type ProgressLineInput = {
  status: WbsItemStatus | undefined
  wbsItemType: WbsItemTypeVO | undefined
  scheduledStartDate: Date | undefined
  scheduledEndDate: Date | undefined
  progressRate: number // 0-1
  hasChildren: boolean
}

export const calcTodayXPercent = (
  datePositions: DatePosition[],
  endOfToday: CalendarDateVO
): number | null => {
  const todayPos = datePositions.find(p => p.date.isEqual(endOfToday))
  if (!todayPos) return null
  return todayPos.x - todayPos.width / 2
}

export const calcProgressLineXPercent = (
  input: ProgressLineInput,
  timeScale: CalendarDateVO[],
  today: Date,
  todayXPercent: number
): number => {
  const {
    status,
    wbsItemType,
    scheduledStartDate,
    scheduledEndDate,
    progressRate,
    hasChildren,
  } = input

  if (!status) return todayXPercent

  const isTask = wbsItemType?.isTask() ?? false
  const isTaskWithoutChildren = isTask && !hasChildren

  switch (status) {
    case WbsItemStatus.TODO: {
      if (!scheduledStartDate) return todayXPercent
      if (scheduledStartDate < today) {
        if (!scheduledEndDate) return todayXPercent
        return calcProgressPositionPercent(
          scheduledStartDate,
          scheduledEndDate,
          0,
          timeScale
        )
      }
      return todayXPercent
    }

    case WbsItemStatus.DOING:
    case WbsItemStatus.REVIEW: {
      if (isTaskWithoutChildren) return todayXPercent
      if (!scheduledStartDate || !scheduledEndDate) return todayXPercent
      if (progressRate <= 0) return todayXPercent
      return calcProgressPositionPercent(
        scheduledStartDate,
        scheduledEndDate,
        progressRate,
        timeScale
      )
    }

    case WbsItemStatus.DONE:
    case WbsItemStatus.DISCARD: {
      if (!scheduledEndDate) return todayXPercent
      if (scheduledEndDate > today) {
        if (!scheduledStartDate) return todayXPercent
        return calcProgressPositionPercent(
          scheduledStartDate,
          scheduledEndDate,
          1.0,
          timeScale
        )
      }
      return todayXPercent
    }

    default:
      return todayXPercent
  }
}
